import {
  getNotifications as getNotificationsService,
  markNotificationAsRead as markNotificationAsReadService,
  markAllNotificationsAsRead as markAllNotificationsAsReadService,
} from '../../services/notificationsService';
import {
  NOTIFICATIONS_GET_ALL_REQUEST,
  NOTIFICATIONS_GET_ALL_SUCCESS,
  NOTIFICATIONS_GET_ALL_FAILURE,
  NOTIFICATIONS_MARK_AS_READ_REQUEST,
  NOTIFICATIONS_MARK_AS_READ_SUCCESS,
  NOTIFICATIONS_MARK_AS_READ_FAILURE,
  NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST,
  NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS,
  NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE,
} from '../../actions/actionTypes';

export function getNotifications() {
  return {
    types: [
      NOTIFICATIONS_GET_ALL_REQUEST,
      NOTIFICATIONS_GET_ALL_SUCCESS,
      NOTIFICATIONS_GET_ALL_FAILURE,
    ],
    promise: getNotificationsService(),
  };
}

export function markNotificationAsRead(notificationId) {
  return {
    types: [
      NOTIFICATIONS_MARK_AS_READ_REQUEST,
      NOTIFICATIONS_MARK_AS_READ_SUCCESS,
      NOTIFICATIONS_MARK_AS_READ_FAILURE,
    ],
    promise: markNotificationAsReadService(notificationId),
  };
}

export function markAllNotificationsAsRead(notificationIds) {
  return {
    types: [
      NOTIFICATIONS_MARK_ALL_AS_READ_REQUEST,
      NOTIFICATIONS_MARK_ALL_AS_READ_SUCCESS,
      NOTIFICATIONS_MARK_ALL_AS_READ_FAILURE,
    ],
    promise: markAllNotificationsAsReadService(notificationIds[0]),
  };
}
